//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminBillingDocumentController_createCreditNoteV3,
  Response$AdminBillingDocumentController_createCreditNoteV3$Status$201,
  ResponseContentType$AdminBillingDocumentController_createCreditNoteV3,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminBillingDocumentController_createCreditNoteV3 = () =>
  useApiClientMutation<
    Params$AdminBillingDocumentController_createCreditNoteV3,
    Response$AdminBillingDocumentController_createCreditNoteV3$Status$201[ResponseContentType$AdminBillingDocumentController_createCreditNoteV3]
  >({ method: 'AdminBillingDocumentController_createCreditNoteV3' });
